module.exports = __webpack_public_path__ + "img/pearl.be5030ca.webp";